import uniqBy from "lodash/uniqBy";

import {IntermediatePart} from "../intermediatePart";
import store from "../../../../store";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

export default class CountertopCommon extends IntermediatePart {

  constructor(props) {
    super(props);
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);

    let newFeatures = this.getSameEdgesFeatures(featuresToDisplay);

    const featuresThatLeft = featuresToDisplay.filter(feature => {
      return !newFeatures.some(newFeature => newFeature.dbFeature.customDisplayName === feature.dbFeature.customDisplayName)
    });

    featuresThatLeft.forEach(feature => {
      let currentFeatureName = feature.getCountertopGroupsSplittedFeatureName();
      if (newFeatures.every(countertopFeature => {
        let customDisplayName = countertopFeature.getCountertopGroupsSplittedFeatureName();
        return customDisplayName !== currentFeatureName
      })) {
        newFeatures.push(feature);
      }
    });

    return uniqBy(newFeatures, (feature) => feature.dbFeature.id)
      .map(_ => new DesignNavigationItem(_.featureName, _));
  }

  getSameEdgesFeatures(featuresToDisplay) {
    const filterGroups = store.getState().filterState.filterGroups;
    const edgeFilterGroup = filterGroups.find(group => group.name === "Edge" || group.name === "Edge Profile");
    if (edgeFilterGroup) {
      let activeFeatureEdgeFilter = this.getFeatureEdgeFilter(this.activeFeature, edgeFilterGroup); // 1) take edge filter from active feature
      if (!activeFeatureEdgeFilter) { // 2) try to set it from active edge feature group active feature
        const edgeFeatureGroup = this.getParent().edge;
        if (edgeFeatureGroup && edgeFeatureGroup.activeFeature) {
          activeFeatureEdgeFilter = this.getFeatureEdgeFilter(edgeFeatureGroup.activeFeature, edgeFilterGroup);
        }
      }
      if (!activeFeatureEdgeFilter) { // 3) find at least some feature with edge filter
        for (let i = 0; i < featuresToDisplay.length; i++) {
          const edgeFilters = this.getFeatureEdgeFilter(featuresToDisplay[i], edgeFilterGroup);
          if (edgeFilters) {
            activeFeatureEdgeFilter = edgeFilters;
            break;
          }
        }
      }
      if (activeFeatureEdgeFilter) {
        const activeEdgeFilter = activeFeatureEdgeFilter[0];
        const activeEdgeFilter2 = activeFeatureEdgeFilter[1];
        featuresToDisplay = featuresToDisplay.filter((feature) => {
          if (feature.notAvailableInVisualizer) {
            return false
          }
          const currentFeatureFilters = this.getFeatureEdgeFilter(feature, edgeFilterGroup);
          return currentFeatureFilters && (currentFeatureFilters.includes(activeEdgeFilter) || (
            activeEdgeFilter2 && currentFeatureFilters.includes(activeEdgeFilter2)
          ))
        });
      }
    }
    return featuresToDisplay
  }

  getFeatureEdgeFilter = (feature, edgeFilterGroup) => {
    if (!feature) {
      return null
    }
    if (!edgeFilterGroup) {
      const filterGroups = store.getState().filterState.filterGroups;
      edgeFilterGroup = filterGroups.find(group => group.name === "Edge" || group.name === "Edge Profile");
    }
    return feature.dbFeature.fabFilterValueIDs[edgeFilterGroup.id] || feature.dbFeature.filterValueIDs[edgeFilterGroup.id]
  };

  tryToSetTheSameFeature(filteredFeatures = [], partName = "") {
    if (this.activeFeature && this.activeFeature.partName) {
      let splittedFromTheLayoutName = partName
        ? this.removeLayoutFromPartName(partName)
        : this.activeFeature.getMatchingFeatureName();
      const allEdgesCountertops = filteredFeatures.filter(feature => {
        return feature.getMatchingFeatureName() === splittedFromTheLayoutName
      });
      const sameEdgeCountertops = this.getSameEdgesFeatures(allEdgesCountertops);
      this.activeFeature = sameEdgeCountertops[0] || allEdgesCountertops[0] || null
      if (this.activeFeature) {
        return true
      }
    }
    return false
  }

  setDefault() {
    const filteredFeatures = this.getArrayOfConditions
      ? this.features.filter(f => f.dbFeature.s3Bindings && f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))
      : this.features;
    const matchingFeatureExist = this.tryToSetTheSameFeature(filteredFeatures, null);
    if (!matchingFeatureExist) {
      const edge = this.getParent().edge;
      let matchingEdgeFeature = null;
      if (edge && edge.activeFeature) {
        matchingEdgeFeature = edge.getMatchingCounterTop(edge.activeFeature, filteredFeatures);
      }
      this.activeFeature = matchingEdgeFeature || filteredFeatures[0];
    }
    if (this.setActiveFeatureParts) {
      this.activeFeatureParts = this.setActiveFeatureParts();
    }
  }

}
